export { default } from './CreditsAmountSlider';
